/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_ExpandInputs */

const en_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand the event text horizontally`)
};

const fr_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etendre le texte de l'evenement horizontalement`)
};

const de_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den Ereignistext horizontal ausdehnen`)
};

const it_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espandi orizzontalmente il testo dell'evento`)
};

const ru_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разверните текст события по горизонтали.`)
};

const es_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir el texto del evento horizontalmente`)
};

const zh_cn2_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平展开事件文本`)
};

const ja_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストを水平に拡大する`)
};

const hi_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट को क्षैतिज रूप से विस्तारित करें`)
};

const pt_pt2_shortcut_keys_desc_expand = /** @type {(inputs: Shortcut_Keys_Desc_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expanda o texto do evento horizontalmente.`)
};

/**
* | output |
* | --- |
* | "Expand the event text horizontally" |
*
* @param {Shortcut_Keys_Desc_ExpandInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_expand = /** @type {((inputs?: Shortcut_Keys_Desc_ExpandInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_ExpandInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_expand(inputs)
	if (locale === "de") return de_shortcut_keys_desc_expand(inputs)
	if (locale === "it") return it_shortcut_keys_desc_expand(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_expand(inputs)
	if (locale === "es") return es_shortcut_keys_desc_expand(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_expand(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_expand(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_expand(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_expand(inputs)
	return en_shortcut_keys_desc_expand(inputs)
});